import autobind from 'autobind-decorator';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { RenderPropWithProps } from '../../../../common/types/prop-types/common';
import { RouteProps } from '../../../../common/types/prop-types/common';
import { config } from '../../../common';

export interface NoVehicleContainerProps {
    showRedirectButton: boolean;
    onClick: (event: React.MouseEvent<{}> | null) => void;
}

export interface NoVehicleProps { }

interface NoVehicleContainerState {
    showRedirectButton: boolean;
}

class NoVehicleContainer extends Component<
    RenderPropWithProps<NoVehicleContainerProps> &
    RouteProps
    > {
    public static propTypes = {
        routeProps: PropTypes.any.isRequired,
    };

    public readonly state: NoVehicleContainerState = {
        showRedirectButton: true,
    };

    @autobind
    public async onClick(e: React.MouseEvent<{}> | null) {
        if (e) {
            e.preventDefault();
        }
        window.location.href = config.BaseURL + '/profile';
        // this.props.routeProps.history.push('profile');
    }

    public componentDidMount() {
        if (this.props.routeProps.location.pathname.includes('profile')) {
            this.setState({
                showRedirectButton: false,
            });
        }
    }

    public render() {
        const newprops: NoVehicleContainerProps = {
            onClick: this.onClick,
            showRedirectButton: this.state.showRedirectButton,
        };

        return this.props.children(newprops);
    }
}

export default NoVehicleContainer;
